exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timelineTrackScreenshot{position:relative;background:var(--grey-20);overflow:hidden}.timelineTrackScreenshotImgContainer{position:absolute;overflow:hidden;display:flex;justify-content:center}.timelineTrackScreenshotImgContainer:after{content:\"\";position:absolute;top:0;width:1px;height:100%;background:var(--grey-30);right:0}.timelineTrackScreenshotHover{position:absolute;pointer-events:none;z-index:4}.timelineTrackScreenshotHoverImg{position:relative;left:-50%;border-radius:5px;padding:.5px;border:.5px solid rgba(0,0,0,.2);box-shadow:0 2px 4px rgba(0,0,0,.2)}", ""]);

// exports
